/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgVerticalBarBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 2L2.5 23M12.7308 6.9L12.7308 4.1C12.7308 3.91435 12.6538 3.7363 12.5167 3.60502C12.3797 3.47375 12.1938 3.4 12 3.4L2.5 3.4L2.5 7.6L12 7.6C12.1938 7.6 12.3797 7.52625 12.5167 7.39497C12.6538 7.2637 12.7308 7.08565 12.7308 6.9ZM21.5 13.9L21.5 11.1C21.5 10.9143 21.423 10.7363 21.286 10.605C21.1489 10.4738 20.963 10.4 20.7692 10.4L2.5 10.4L2.5 14.6L20.7692 14.6C20.963 14.6 21.1489 14.5262 21.286 14.395C21.423 14.2637 21.5 14.0857 21.5 13.9ZM17.1154 20.9L17.1154 18.1C17.1154 17.9143 17.0384 17.7363 16.9013 17.605C16.7643 17.4737 16.5784 17.4 16.3846 17.4L2.5 17.4L2.5 21.6L16.3846 21.6C16.5784 21.6 16.7643 21.5262 16.9013 21.395C17.0384 21.2637 17.1154 21.0857 17.1154 20.9Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgVerticalBar = wrapIcon(SvgVerticalBarBase);
export default SvgVerticalBar;
